<template>
    <div>
        <b-row>
            <b-col class="mb-2" sm="12" lg="6">
                <!-- Service info -->
                <b-card tag="article" class="mb-2 card-custom">
                    <b-card-text>
                        <div class="d-flex justify-content-between">
                            <h5 class="font-weight-bolder">Service</h5>
                            <h5 class="text-muted font-weight-light">#{{ ride.serviceNumber }}</h5>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div>Sales Channel Ref.</div>
                            <div class="text-muted font-weight-light">
                                {{ ride.salesChannelReference }}
                            </div>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div>Pickup Datetime</div>
                            <div class="text-muted font-weight-light">
                                {{ ride.pickupDatetime }}
                            </div>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div><span class="text-danger font-weight-bolder">(A)</span>
                                Pickup
                            </div>
                            <div class="text-muted font-weight-light">
                                {{ pickupNamed }}
                            </div>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div><span class="text-danger font-weight-bolder">(B)</span>
                                Dropoff
                            </div>
                            <div class="text-muted font-weight-light">
                                {{ dropoffNamed }}
                            </div>
                        </div>
                    </b-card-text>
                </b-card>
                <!-- End service info -->
            </b-col>
        </b-row>

        <!-- Render google map solo si hay datos para mostrar -->
        <g-map
            v-if="shouldRenderMap"
            ref="map-tracking-status"
        ></g-map>
        <div v-else-if="!loading">
            <p>No hay datos de rastreo disponibles para mostrar en el mapa.</p>
        </div>
        <div v-if="loading">
            <p>Cargando datos...</p>
        </div>


        <div class="main-card">
            <b-overlay :show="loading" no-wrap rounded></b-overlay>
            <div v-if="trackStatusLogs.length==0 && !loading" class="text-center">
                <label  class="text-center">
                    No se encontrarón resultados.
                </label>
            </div>
            
            <b-table v-else 
                :items="trackStatusLogs" 
                :fields ="colsTableLogs" 
                class="mt-3"
                striped
                hover
                responsive
                bordered
                stacked="lg"
                small>

                <!-- A virtual column -->
                <template #cell(index)="data">
                    <div class="text-center"  @click="toggleIcon(data.item)">
                        <span class="text-danger font-weight-bolder mr-1">({{ data.index + 1 }})</span>
                        <md-icon 
                            class="text-info"
                            v-if="data.item.showIcon" 
                            icon="visibility"
                        />
                        <md-icon 
                            v-else 
                            icon="visibility_off"
                        />
                    </div>
                </template>

                <template #cell(transportServiceTrackingStatus)="row">
                    {{ row.item.transportServiceTrackingStatus }}
                </template>

                <template #cell(creationDatetime)="row">
                    <date-label :date="row.item.creationDatetime"/>
                </template>
                <template #cell(creationDatetimeLocal)="row">
                    <div>
                        {{ row.item.creationDatetimeLocal }}
                        <small class="text-muted">({{ row.item.timeZoneLocal }})</small>
                    </div>
                </template>
            </b-table>
        </div>



    </div>
</template>
<script>
import gMap from "../../rate-plans/Map.vue"
import api from "../../../../api.js";
import DateLabel from "../../../helpers/DateLabel.vue"

export default {
    name: "mapEvents",
    components: { gMap, DateLabel },
    props: {
        ride: {
            type: Object,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            trackStatusLogs: [],
            loading: false,
            colsTableLogs: [
				{ key: 'index', label: 'Points'},
				{ key: 'transportServiceTrackingStatus', label: 'Track. status' },
				{ key: 'creationDatetime', label: 'Date Time UTC' },
				{ key: 'creationDatetimeLocal', label: 'Date time Local'},
				{ key: 'latitude', label: 'Lat.' },
				{ key: 'longitude', label: 'Lng.' },
				{ key: 'driverName', label: 'Conductor' },
			]
        }
    },
    computed: {
        shouldRenderMap() {
            return (
                this.ride &&
                this.ride.pickup_place &&
                this.ride.dropoff_place &&
                (this.trackStatusLogs.length > 0)
            );
        },
        pickupNamed() {
            let pickup = this.ride.pickup_place.name
            return pickup.substring(0, 45)
        },
        dropoffNamed() {
            let dropoff = this.ride.dropoff_place.name
            return dropoff.substring(0, 45)
        }
    },
    methods: {
        resetDistributed() {
			this.trackStatusLogs = [];
		},
        async fetchAssignedData() {

            if (!this.ride?.id) return;

			this.resetDistributed();
			this.loading = true;
            try {
                const res = await api(this).get(`/tracking/driver/assigned/${this.ride.id}`);
                this.trackStatusLogs = res.data.logsTrackingStatus;
                this.trackStatusLogs = this.trackStatusLogs.map(item => ({
                ...item,
                    showIcon: true // o true
                }));

                // Solo si el mapa ya está montado y hay datos, marcar los puntos
                this.$nextTick(() => {
                    if (this.$refs["map-tracking-status"] && this.shouldRenderMap) {
                        this.$refs["map-tracking-status"].createMarks(this.gMarks());
                    }
                });
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                this.loading = false;
            }
		},
        gMarks() {

            const arrayDriverTrack = [];

            if (!this.ride?.pickup_place || !this.ride?.dropoff_place) return arrayDriverTrack;

            const pickup = {
                ...this.ride.pickup_place,
                label: 'A',
                content: this.ride.pickup_place.name,
                //icon: {
                    //url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
                //}
            };

            const dropoff = {
                ...this.ride.dropoff_place,
                label: 'B',
                content: this.ride.dropoff_place.name,
                //icon: {
                    //url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                //}
            };

            arrayDriverTrack.push(pickup, dropoff);

            this.trackStatusLogs.forEach((item, index) => {
                if (item.showIcon == true) {
                    arrayDriverTrack.push({
                        ...item,
                        label: (index+1).toString(),
                        content: `${item.transportServiceTrackingStatus}<br>${item.creationDatetimeLocal}`,
                    });
                }
            });

            return arrayDriverTrack;
        },
        getIconColor() {
            return `https://maps.google.com/mapfiles/ms/icons/blue-dot.png`;
        },
        toggleIcon(item) {
            item.showIcon = !item.showIcon;
            this.$refs["map-tracking-status"].createMarks(this.gMarks());
        }
    },
    watch: {
        ride: {
            handler(newVal) {
                if (newVal) {
                    this.fetchAssignedData();
                }
            },
            immediate: true,
            deep: true,
        },
    }
}

</script>